import React from 'react';

interface CTAButtonProps {
  text: string;
  variant?: 'glow' | 'primary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  showArrow?: boolean;
}

export function CTAButton({
  text,
  variant = 'glow',
  size = 'md',
  showArrow = false
}: CTAButtonProps) {
  const sizeStyles: Record<string, React.CSSProperties> = {
    sm: { padding: '8px 14px', fontSize: 12, borderRadius: 8 },
    md: { padding: '12px 22px', fontSize: 14, borderRadius: 999 },
    lg: { padding: '16px 28px', fontSize: 17, borderRadius: 999 },
  };

  const variantStyles: Record<string, React.CSSProperties> = {
    glow: {
      background: '#FFE17D',
      color: '#1C2230',
      boxShadow: '0 10px 40px rgba(255,225,125,0.18)',
    },
    primary: {
      background: '#6366F1',
      color: '#FFFFFF',
    },
    outline: {
      background: 'transparent',
      color: '#EDEDED',
      border: '1px solid rgba(255,255,255,0.2)',
    },
  };

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        fontWeight: 700,
        letterSpacing: '-0.01em',
        ...sizeStyles[size],
        ...variantStyles[variant],
      }}
    >
      {text}
      {showArrow && (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5 12h14M13 5l7 7-7 7" />
        </svg>
      )}
    </div>
  );
}
